export default __webpack_public_path__ + "static/media/socks.51406a3c.jpeg";